import type { OutputLayer } from '@/components/preview/output-layer-preview';

/** Hide media-agent LiveKit rows while a cold deck open is in flight (matches player shield). */
export function applyPresentationTransitionShield(
  layers: OutputLayer[],
  presentationTransitionInFlight: boolean,
): OutputLayer[] {
  if (!presentationTransitionInFlight || layers.length === 0) {
    return layers;
  }
  return layers.map((layer) => {
    const isAgentLiveKit =
      layer.componentId === 'livekitTrackMediaAgent' ||
      (typeof layer.itemId === 'string' && layer.itemId.startsWith('mediaAgent:'));
    if (!isAgentLiveKit) {
      return layer;
    }
    if (layer.visible === false && layer.audible === false) {
      return layer;
    }
    return { ...layer, visible: false, audible: false };
  });
}
